import * as React from "react";
import { forwardRef } from "react";
const SvgWhiteIcon = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("rect", { width: 40, height: 40, rx: 20, fill: "white" }));
const ForwardRef = forwardRef(SvgWhiteIcon);
export { ForwardRef as ReactComponent };
